export default {
  data() {
    return {
      initState: {},
      routeGuard: true,
    };
  },
  methods: {
    storeInitState() {
      const { initState, ...state } = this.$data;
      this.initState = JSON.stringify(state);
    },
  },
  beforeRouteLeave(to, from, next) {
    const { initState, ...currentState } = this.$data;
    /*
    https://tracker.globetrack.ie/issues/6486
    if (from.path.indexOf("new") > -1) {
      next();
      return;
    }
    */
    const itsNewlyCreated =
      from.fullPath.indexOf("new") > -1 && to.fullPath.indexOf("edit") > -1;
    if (
      this.initState != JSON.stringify(currentState) &&
      this.routeGuard &&
      !itsNewlyCreated
    ) {
      const answer = window.confirm(
        "Do you really want to leave? You may have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};



// WEBPACK FOOTER //
// ./src/mixins/UnsavedChangesGuard.js